import { IEntityRepository } from '@awesome-ecs/abstract/entities';
import { ISystemsRuntime } from '@awesome-ecs/abstract/systems';
import { ILogger } from '@awesome-ecs/abstract/utils';
import { PipelineResult } from '@awesome-ecs/abstract/pipelines';
import { WorkerStatus } from '../components/worker-instance';
import { IWorkerMessageQueue } from '../abstract/worker-queue';
import { WorkerThreadEntity } from '../entities/worker-thread';
import { WorkerEntityType } from '../abstract/types/entity-type';

// @injectable
export class WorkerSystemRuntime implements ISystemsRuntime {
  constructor(
    private workerMessageQueue: IWorkerMessageQueue,
    private entityRepository: IEntityRepository,
    private logger: ILogger
  ) {}

  runTick(): PipelineResult {
    const message = this.workerMessageQueue.peek();

    if (!message) {
      return;
    }

    const workers = this.entityRepository.getAll<WorkerThreadEntity>(WorkerEntityType.workerThread);

    if (!workers) {
      this.logger.warn('No WorkerThreadEntity was registered for type: ', message.workerType);
      return;
    }

    let availableWorker: WorkerThreadEntity;

    for (const worker of workers) {
      if (worker.instance.status === WorkerStatus.available) {
        availableWorker = worker;
        break;
      }
    }

    if (!availableWorker) {
      this.logger.debug(
        'No available worker found. Skipping current tick.',
        message.workerType,
        message.messageUid
      );
      return;
    }

    this.logger.debug('Sending message to Worker', availableWorker.identity.model.uid, message);

    availableWorker.instance.worker.postMessage(message);
    availableWorker.instance.status = WorkerStatus.busy;

    this.workerMessageQueue.dequeue();
  }
}
